import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { QuestionIcon } from 'icons/QuestionIcon/QuestionIcon'
import { Tooltip } from '@junglescout/edna'

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${props => props.margin};
`

export const QuestionTooltip = ({
  content,
  tooltipSize,
  iconSize,
  side,
  align,
  margin
}) => (
  <Tooltip size={tooltipSize} side={side} align={align} content={content}>
    <IconWrapper margin={margin}>
      <QuestionIcon size={iconSize} data-testid="question-icon-tooltip" />
    </IconWrapper>
  </Tooltip>
)

QuestionTooltip.defaultProps = {
  align: 'center',
  iconSize: '16px',
  margin: undefined,
  side: 'bottom',
  tooltipSize: 'medium'
}

QuestionTooltip.propTypes = {
  align: PropTypes.oneOf(['start', 'center', 'end']),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  iconSize: PropTypes.string,
  margin: PropTypes.string,
  side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  tooltipSize: PropTypes.string // see size prop in Tooltip Storybook for options https://storybook.junglescout.com/?path=/story/components-tooltip--example
}
